module.exports = __webpack_public_path__ + "img/202115_200height.184fdaaa.png";